var _path, _path2, _path3, _g, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReturnsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.28949 4.16974C2.28851 3.13352 3.12826 2.29297 4.16449 2.29297H15.8371C16.8728 2.29297 17.7123 3.1327 17.7121 4.1684L17.7095 15.8351C17.7092 16.8704 16.8698 17.7097 15.8345 17.7097H4.17548C3.14064 17.7097 2.30146 16.8713 2.30048 15.8364L2.28949 4.16974Z",
    stroke: "#404553",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49084 13.2725H7.49594H10.0039C12.3047 13.2725 14.1698 11.4073 14.1698 9.10657C14.1692 6.80372 12.3031 4.93823 10.0015 4.93823H7.5015",
    fill: "#00B4D7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_121_57",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 4,
    width: 8,
    height: 10
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49084 13.2725H7.49594H10.0039C12.3047 13.2725 14.1698 11.4073 14.1698 9.10657C14.1692 6.80372 12.3031 4.93823 10.0015 4.93823H7.5015",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_121_57)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.49239 12.0225C7.49358 12.0225 7.49477 12.0225 7.49595 12.0225V14.5225C7.49374 14.5225 7.49153 14.5225 7.48932 14.5225L7.49239 12.0225ZM7.49595 12.0225H10.0039V14.5225H7.49595V12.0225ZM10.0039 12.0225C11.6143 12.0225 12.9198 10.717 12.9198 9.10657L15.4198 9.10621C15.4198 12.0973 12.9951 14.5225 10.0039 14.5225V12.0225ZM12.9198 9.10657C12.9194 7.49369 11.6127 6.18823 10.0015 6.18823V3.68823C12.9936 3.68823 15.419 6.11337 15.4198 9.10621L12.9198 9.10657ZM10.0015 6.18823H7.50151V3.68823H10.0015V6.18823Z",
    fill: "#404553"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00833 10.2869L6.65131 12.644L9.00833 15.001",
    stroke: "#404553",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnsIcon);
export default __webpack_public_path__ + "static/media/returns-icon.977ede71f56f347f62fcb7bf7bc0d956.svg";
export { ForwardRef as ReactComponent };